var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.05C5.3866 7.05 5.7 7.3634 5.7 7.75V9.25C5.7 9.6366 5.3866 9.95 5 9.95C4.6134 9.95 4.3 9.6366 4.3 9.25V7.75C4.3 7.3634 4.6134 7.05 5 7.05Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.05C9.3866 7.05 9.7 7.3634 9.7 7.75V9.25C9.7 9.6366 9.3866 9.95 9 9.95C8.6134 9.95 8.3 9.6366 8.3 9.25V7.75C8.3 7.3634 8.6134 7.05 9 7.05Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5244C6.51888 11.5244 6.11462 11.1953 6 10.75H8.00001C7.88539 11.1953 7.48113 11.5244 7 11.5244Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23607 0C3.47852 0 2.786 0.428004 2.44721 1.10557L1.10557 3.78885C1.03615 3.92771 1 4.08082 1 4.23607V12C1 13.1046 1.89543 14 3 14H11C12.1046 14 13 13.1046 13 12V4.23607C13 4.08082 12.9639 3.92771 12.8944 3.78885L11.5528 1.10557C11.214 0.428005 10.5215 0 9.76393 0H4.23607ZM2.9999 5.5C2.66853 5.5 2.3999 5.76863 2.3999 6.1V12C2.3999 12.3314 2.66853 12.6 2.9999 12.6H10.9999C11.3313 12.6 11.5999 12.3314 11.5999 12V6.1C11.5999 5.76863 11.3313 5.5 10.9999 5.5H2.9999Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.3443bfcd.svg";
export { ForwardRef as ReactComponent };